import React, { Component } from 'react';
import SectionFour from '../components/home/SectionFour';
import SectionOne from '../components/home/SectionOne';
import SectionTwo from '../components/home/SectionTwo';
import SectionThree from '../components/home/SectionThree';
import SectionFive from '../components/home/SectionFive';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as actions from '../store/actions';
import LoadComponent from '../hoc/LoadComponent';
import './HomePage.css';

const TopBar = LoadComponent(() => {
    return import('../components/home/TopBar');
});

class HomePage extends Component {

    componentDidMount() {
        if (localStorage.getItem('app.profile.isFirstLogin')) {
            this.props.openPopUp('FirstTimeLogin', {
                isFirstTimeLogin: true,
                userName: localStorage.getItem('app.profile.username'),
                email: localStorage.getItem('app.profile.emailAddress'),
                contact: localStorage.getItem('app.profile.phoneNumber')
            })
        }

        if (!Boolean(localStorage.getItem('app.profile.isFirstLogin')) && localStorage.getItem('app.profile.isEmptySecretQnA') === 'true') {
            this.props.openPopUp('UpdateSecurityQnA');
        }

        if (localStorage.getItem('PasswordResetUrl') != null) 
        {
            this.props.openPopUp('PasswordResetForm');
            localStorage.removeItem('PasswordResetUrl');
        }
    }

    render() {
        return (
            <React.Fragment>
                <TopBar />
                <div className='section-one-background'>
                    <SectionOne toggleRegistration={this.toggleRegistrationPopUp} />
                </div>
                <SectionTwo />
                <div className='section-three-background'>
                    <SectionThree toggleRegistration={this.toggleRegistrationPopUp} />
                </div>
                <SectionFour toggleRegistration={this.toggleRegistrationPopUp} />
                <div className='section-five-background'>
                    <SectionFive />
                </div>
            </React.Fragment>
        );
    }
};

const mapStateToProps = state => {
    return {
        mobile: state.responsiveui.mobile
    };
};

const mapDispatchToProps = dispatch => {
    return {
        openPopUp: (type) => dispatch(actions.openPopUp(type))
    };
};

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(HomePage)
);
